// Rounds a number to a specified number of decimal places
export function roundDecimal(value, decimalPlaces = 2) {
    const factor = 10 ** decimalPlaces;
    return Math.round(value * factor) / factor;
}
/**
 * Rounds using "round half up" — at exactly .5 boundary (within IEEE 754 tolerance),
 * always rounds up. Matches the display rounding in secondsToHoursFixed.
 */
export function roundHalfUp(value, decimals) {
    const d = 10 ** decimals;
    const n = value * d;
    const i = Math.floor(n);
    const f = n - i;
    if (Math.abs(f - 0.5) < 1e-8)
        return (i + 1) / d;
    return Math.round(n) / d;
}
// Converts degrees to radians
export const toRadians = (val) => (val * Math.PI) / 180;
//# sourceMappingURL=math.js.map